/**
 * Main App Component
 * Wrapped with ShopThemeProvider to apply shop theme globally
 *
 * UAT Preview Deployment Verification: Feb 10, 2026
 */

import React, { useEffect } from 'react';
import { View } from 'react-native';
import { ShopThemeProvider } from '@app/core';
import { AppRouter } from './AppRouter';

export const App: React.FC = () => {
  useEffect(() => {
    console.log('✅ [App] UAT Preview Deployment Active - Version 2.0.0');
    console.log('📅 [App] Deployment Date: Feb 10, 2026');
    console.log('🌿 [App] Branch: dev (preview environment)');
  }, []);

  return (
    <ShopThemeProvider>
      <View style={{ flex: 1 }}>
        <AppRouter />
      </View>
    </ShopThemeProvider>
  );
};

